const API_BASE_URL = process.env.BASE_URL

export const FILE_UPLOAD_ENDPOINTS = {
    UPLOAD_CONFIG: API_BASE_URL + "/{service_company_slug}/api/{object_type}/{object_id}/upload-config/",
    PENDING_UPLOAD_CONFIG: API_BASE_URL + "/api/pending-uploads/upload-config/",
    REMOVE_ORPHANED_FILE: API_BASE_URL + "/api/pending-uploads/remove-orphaned-file/",
    ATTACHMENTS: API_BASE_URL + "/{service_company_slug}/api/{object_type}/{object_id}/attachments/",
    ATTACHMENT: API_BASE_URL + "/{service_company_slug}/api/{object_type}/{object_id}/attachments/{attachment_id}/",
}
